import React from 'react';
import PropTypes from 'prop-types';
import ImageGroup from './ImageGroup';

const Image = ({ src, alt, ref, height, width, fit, auto }) => {
  return (
    <img
      ref={ref}
      srcSet={src}
      src={src}
      style={{
        width: width || '100%',
        height: height,
        objectFit: fit || 'contain',
        fit: fit,
        auto: auto || '',
        display: 'block',
        backgroundColor: '#f5f5f5',
      }}
      alt={alt}
      loading='lazy'
    />
  );
};

// Dodajemo podkomponentu
Image.Group = ImageGroup;

// PropTypes za validaciju propsa
Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  circular: PropTypes.bool,
  centered: PropTypes.bool,
  className: PropTypes.string,
};

Image.defaultProps = {
  alt: '',
  circular: false,
  centered: false,
};

export default Image;
